import { RootState } from '../store';
import { SfState } from './types';

export const selectSalesforce = (state: RootState): SfState => state.salesforce;
